import React from 'react'
import { Box } from '@material-ui/core'
import ConsumerTable from '../../table/consumerTable'
// import { GeneralSearch } from "components/search";

export default function ConsumerListingPanelComponent({
    consumers,
    customField,
    isFetching,
    page,
    search,
    rowsPerPage,
    totalRecords,
    handleChangePage,
    handleChangeRowsPerPage,
    handleEditLoyaltyPoint,
    handleSearch,
    handleReload,
    paginationOptions
}) {
    return (
        <Box pt={2}>
            {/* <GeneralSearch
                handleFilter={(value) => {
                    handleSearch(value);
                }}
                isFetching={isFetching}
            /> */}
            <ConsumerTable
                consumers={consumers}
                customField={customField}
                isFetching={isFetching}
                page={page}
                search={search}
                rowsPerPage={rowsPerPage}
                totalRecords={totalRecords}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleReload={handleReload}
                paginationOptions={paginationOptions}
                handleEditLoyaltyPoint={handleEditLoyaltyPoint}
                handleSearch={handleSearch}
            />
        </Box>
    )
}
